/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Nexata_File_Search_ErrorInputs */

const es_tools_nexata_file_search_error = /** @type {(inputs: Tools_Nexata_File_Search_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al buscar archivos`)
};

const en_tools_nexata_file_search_error = /** @type {(inputs: Tools_Nexata_File_Search_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error searching files`)
};

/**
* | output |
* | --- |
* | "Error searching files" |
*
* @param {Tools_Nexata_File_Search_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_nexata_file_search_error = /** @type {((inputs?: Tools_Nexata_File_Search_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Nexata_File_Search_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_nexata_file_search_error(inputs)
	return en_tools_nexata_file_search_error(inputs)
});
export { tools_nexata_file_search_error as "tools.nexata.file_search_error" }